module.exports = __webpack_public_path__ + "img/other-contury.fb4fa732.png";